import { Component, Input } from '@angular/core';
import { ExternalMember } from '../../../shared/models/member/external-member.model';

@Component({
  selector: 'def-b2c-registration-form',
  templateUrl: './b2c-registration-form.component.html',
})
export class B2cRegistrationFormComponent {
  @Input() member: ExternalMember;
}
